import { format, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm');
}


export function fDateTimeCustom(date, otp={}) {
  return format(new Date(date), otp?.format ? otp.format : 'dd/MM/yyyy');
}

export function fDateTimeApi(date) {
  return format(new Date(date), 'yyyy/MM/dd HH:mm');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}
